<template>
  <BaseCard type="filled" class="z-10 flex flex-col gap-3 p-4">
    <div class="flex flex-row items-center gap-1">
      <h4 class="text-title-medium grow">{{ material.name }}</h4>
      <BaseChip class="shrink-0">{{ material.materialType.label }}</BaseChip>
    </div>
    <div>
      <h4 class="text-title-small mb-1">
        {{ $t('lumia.material.purpose') }}
      </h4>
      <LessonImpulseField :value="material.purpose" />
    </div>
    <div v-if="material.content && !material.file">
      <h4 class="text-title-small mb-1">{{ $t('lumia.material.content') }}</h4>
      <LessonImpulseField :value="material.content" />
    </div>
    <div v-if="material.file">
      <BaseTextButton color="filled" size="M" icon="download" @click.stop="handleDownload">{{
        $t('lumia.material.download')
      }}</BaseTextButton>
    </div>
  </BaseCard>
</template>
<script lang="ts" setup>
  import BaseCard from '@/core/components/base/card/BaseCard.vue'
  import BaseChip from '@/core/components/base/chip/BaseChip.vue'
  import type { LessonImpulseMaterial } from '../models/lesson-impulse'
  import LessonImpulseField from './LessonImpulseField.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import { useExternalFileDownload } from '@/core/composables/use-external-file-download.ts'

  interface Props {
    material: LessonImpulseMaterial
  }

  const props = defineProps<Props>()

  const { downloadFile } = useExternalFileDownload(() => props.material.file)

  const handleDownload = () => {
    downloadFile()
  }
</script>
